import {
  FETCH_RFQ_FAIL,
  FETCH_RFQ_START,
  FETCH_RFQ_SUCCESS,
  PATCH_RFQ_START,
  PATCH_RFQ_SUCCESS,
  PATCH_RFQ_FAIL,
  SUBMIT_RFQ_START,
  SUBMIT_RFQ_SUCCESS,
  SUBMIT_RFQ_FAIL,
} from "./actions";

const initialState = {
  isSyncing: false,
  hasError: false,
  hasFetchError: false,
  hasPatchError: false,
  hasSubmitError: false,
  id: null,
  positionPriceSum: null,
  currency: null,
  positions: [],
};

export default function rfq(state = initialState, action) {
  switch (action.type) {
    // FETCH

    case FETCH_RFQ_START:
      return {
        ...(state.id === action.payload ? state : initialState),
        isSyncing: true,
        hasFetchError: false,
      };

    case FETCH_RFQ_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isSyncing: false,
        hasFetchError: false,
      };

    case FETCH_RFQ_FAIL:
      return {
        ...state,
        isSyncing: false,
        hasFetchError: true,
      };

    // PATCH

    case PATCH_RFQ_START:
      return {
        ...state,
        isSyncing: true,
        hasPatchError: false,
      };

    case PATCH_RFQ_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isSyncing: false,
        hasPatchError: false,
      };

    case PATCH_RFQ_FAIL:
      return {
        ...state,
        isSyncing: false,
        hasPatchError: true,
      };

    // SUBMIT

    case SUBMIT_RFQ_START:
      return {
        ...state,
        isSyncing: true,
        hasSubmitError: false,
      };

    case SUBMIT_RFQ_SUCCESS:
      return {
        ...state,
        ...action.payload,
        hasSubmitError: false,
        isSyncing: false,
      };

    case SUBMIT_RFQ_FAIL:
      return {
        ...state,
        isSyncing: false,
        hasSubmitError: true,
      };

    default:
      return state;
  }
}

export * from "./actions";
export * from "./selectors";
